
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 21.026a68.333 68.333 0 01-3.08-4.354c-.87-1.341-1.731-2.798-2.374-4.162C.896 11.13.5 9.906.5 9.01.5 5.217 3.432 2.18 7 2.18s6.5 3.036 6.5 6.83c0 .896-.395 2.12-1.046 3.5-.643 1.364-1.505 2.82-2.374 4.162A68.351 68.351 0 017 21.026z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M7.001 11.4c1.289 0 2.334-1.075 2.334-2.4C9.335 7.674 8.29 6.6 7 6.6 5.713 6.6 4.668 7.674 4.668 9c0 1.325 1.045 2.4 2.333 2.4z","stroke":"currentColor"}})])
          )
        }
      }
    